import 'angular:locale/data:en';
import 'zone.js';(globalThis.$localize ??= {}).locale = "en";
